import moment from 'moment';
import ApiService from './api.service';

// actions
export const GET_COMPANIES = 'getCompanies';
export const IMPORT_EWA_TIER = 'importEwaTier';
export const DETAIL_COMPANIES = 'detailCompanies';
export const CREATE_COMPANIES = 'createCompanies';
export const UPDATE_COMPANIES = 'updateCompanies';
export const DEACTIVATE_COMPANY = 'deactivateCompany';
export const DELETE_COMPANIES = 'deleteCompanies';
export const REGISTER_MBAYAR = 'registerMbayar';
export const VALIDATE_OTP_MBAYAR = 'validateOtpMbayar';
export const CHECK_MBAYAR_BALANCE = 'checkBalanceMbayar';
export const GET_COMPANIES_PRIVATE = 'getCompaniesPrivateUser';
export const GET_CITY = 'getCity';
export const GET_PROVINCE = 'getProvince';
export const GET_WALLET_HISTORIES = 'getWalletHistories';
export const DOWNLOAD_WALLET_HISTORIES = 'downloadWalletHistories';
export const GET_BANK_LIST_CASHOUT = 'getBankList';
export const INQUIRY_CASHOUT = 'inquiryCashout';
export const INQUIRY_OTP_CASHOUT = 'inquiryOTPCashout';
export const PROCESS_CASHOUT = 'processCashout';
export const APPROVE_CREATE_COMPANY = 'approveCreateCompany';
export const GET_DRAFT_IMPORT_USER = 'getDraftImportUser';
export const APPROVAL_DRAFT_IMPORT_USER = 'approvelDraftImportUser';
export const GET_MY_BENEFIT_LIST = 'getMyBenefitListFeature';
export const CREATE_MYBEN = 'createMyBen';
export const DETAIL_MYBEN_BY_COMPANY = 'detailMyBenByCompany';
export const UPDATE_STATUS_MYBENEFIT = 'updateStatusMyBen';
export const UPDATE_MY_BENEFIT_V2 = 'updateMyBenV2';
export const UPDATE_EFFECTIVE_DATE = 'updateEffectiveDate';
export const UPDATE_PAYROLL_DATE = 'updatePayrollDate';
export const UPDATE_POLICY = 'updatePolicy';
export const UPDATE_PRODUCT_CONFIG = 'updateProductConfig';
export const GET_REQUEST_COMPANY = 'getRequestCompany';
export const GET_TOTAL_SALARY_COMPANIES = 'getTotalSalaryCompanies';
export const UPDATE_REQUEST_JOIN = 'updateRequestJoin';
export const GET_DETAIL_COMPANY = 'getDetailCompany';
export const GET_SETTING_COMPANY = 'getSettingCompany';
export const GET_FEATURES = 'getFeatures';
export const GET_USAGE = 'getUsage';
export const GET_SETTING_POLICY = 'getSettingPolicy';
export const GET_PRODUCT_SETTING = 'getProductSetting';

// mutations
export const SET_COMPANIES = 'setCompanies';
export const SET_CITY = 'setCity';
export const SET_PROVINCE = 'setProvince';
export const SET_DETAIL_COMPANIES = 'setDetailCompanies';
export const SET_MYBEN_BY_COMPANY = 'setMybenByCompany';
export const SET_COMPANIES_PRIVATE = 'setCompaniesPrivateUser';
export const SET_DRAFT_IMPORT_USER = 'setDraftImportUser';
export const SET_MY_BENEFIT_LIST = 'setMyBenefitListAwa';
export const SET_REQUEST_COMPANY = 'setRequestCompany';
export const SET_TOTAL_SALARY_COMPANIES = 'setTotalSalaryCompanies';
export const SET_DETAIL_COMPANY = 'setDetailCompany';
export const SET_SETTING_POLICY = 'setSettingCompany';
export const SET_SETTING_COMPANY = 'setSettingCompany';
export const SET_FEATURES = 'setFeatures';
export const SET_PRODUCT_SETTING = 'setProductSetting';
export const SET_USAGE = 'setUsage';

const status = {
  active: {
    text: 'Active',
    color: 'tag-success',
  },
  waiting_approval: {
    text: 'Waiting Approval',
    color: 'tag-warning',
  },
  not_active: {
    text: 'Inactive',
    color: 'tag-secondary',
  },
  inactive: {
    text: 'Inactive',
    color: 'tag-secondary',
  },
};

const status_request = {
  submitted: {
    text: 'Submitted',
    color: 'tag-span',
  },
  waiting_verification: {
    text: 'Waiting Verification',
    color: 'tag-warning',
  },
  approved: {
    text: 'Approved',
    color: 'tag-success',
  },
  accepted: {
    text: 'Accepted',
    color: 'tag-success',
  },
  rejected_by_company: {
    text: 'Rejected by Company',
    color: 'tag-danger',
  },
  rejected_by_bd: {
    text: 'Rejected by BD',
    color: 'tag-danger',
  },
  rejected_by_hr: {
    text: 'Rejected by HR',
    color: 'tag-danger',
  },
  cancelled: {
    text: 'Cancelled',
    color: 'tag-danger',
  },
};
const draft_status = {
  approved: {
    text: 'Approved',
    color: 'tag-success',
  },
  waiting_approval: {
    text: 'Waiting Approval',
    color: 'tag-warning',
  },
  rejected: {
    text: 'Rejected',
    color: 'tag-danger',
  },
};
const status_myben = {
  true: {
    text: 'Active',
    color: 'tag-success',
  },
  false: {
    text: 'Inactive',
    color: 'tag-danger',
  },
  inactive: {
    text: 'Inactive',
    color: 'tag-danger',
  },
  active: {
    text: 'Active',
    color: 'tag-success',
  },
};

const state = {
  companies: {},
  company_private_user: {},
  city: {},
  province: {},
  draft_import_user: {},
  request_join: {},
  benefit_list_feature: {},
  myben_company: {},
  salary: {},
  detail_company: {},
  product_setting: {},
  setting_company: {},
  setting_policy: {},
  features: {},
  usage: {},
};

const getters = {
  companies(state) {
    return state.companies;
  },
  myben_company(state) {
    return state.myben_company;
  },
  company_private_user(state) {
    return state.company_private_user;
  },
  city(state) {
    return state.city;
  },
  province(state) {
    return state.province;
  },
  draft_import_user(state) {
    return state.draft_import_user;
  },
  request_join(state) {
    return state.request_join;
  },
  benefit_list_feature(state) {
    return state.benefit_list_feature;
  },
  salary(state) {
    return state.salary;
  },
  detail_company(state) {
    return state.detail_company;
  },
  features(state) {
    return state.features;
  },
  setting_company(state) {
    return state.setting_company;
  },
  setting_policy(state) {
    return state.setting_policy;
  },
  product_setting(state) {
    return state.product_setting;
  },
  usage(state) {
    return state.usage;
  },
};

const actions = {
  [GET_COMPANIES](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/companies', param)
        .then(async ({ data }) => {
          await context.commit(SET_COMPANIES, data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [CREATE_COMPANIES](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.post('api/companies', param)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [IMPORT_EWA_TIER](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.post('api/companies/private-user/ewa/tier', param)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [UPDATE_COMPANIES](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`api/companies/${param.id}`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [DEACTIVATE_COMPANY](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`api/companies/${param.id}/status`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [DELETE_COMPANIES](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`api/companies/${param.id}`)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_TOTAL_SALARY_COMPANIES]({ commit }, { id }) {
    return ApiService.get(`api/companies/${id}/salary`).then(({ data }) => {
      commit(SET_TOTAL_SALARY_COMPANIES, data.data);
      return data.data;
    });
  },
  [GET_REQUEST_COMPANY](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/companies/submission/list`, param)
        .then(async ({ data }) => {
          await context.commit(SET_REQUEST_COMPANY, data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [UPDATE_REQUEST_JOIN](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`api/companies/submission/status`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [REGISTER_MBAYAR](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.post(`api/companies/mbayar/submit?action=${param.action}`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [VALIDATE_OTP_MBAYAR](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.post('api/companies/mbayar/validate', param)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [CHECK_MBAYAR_BALANCE](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/companies/${param.id}/balance`)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_COMPANIES_PRIVATE](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/companies/${param.id}/private-user`, param.query)
        .then(async ({ data }) => {
          await context.commit(SET_COMPANIES_PRIVATE, data.data);
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_CITY](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/users/city`, param.query)
        .then(async ({ data }) => {
          await context.commit(SET_CITY, data.data);
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_PROVINCE](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/users/province`, param.query)
        .then(async ({ data }) => {
          await context.commit(SET_PROVINCE, data.data);
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  [GET_WALLET_HISTORIES](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/companies/${param.id}/balance-histories`, param.query)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [DOWNLOAD_WALLET_HISTORIES](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/companies/${param.id}/balance-histories/download`, param.query)
        .then(async (response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_BANK_LIST_CASHOUT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/companies/cashout/bank-list', param)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [INQUIRY_CASHOUT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/companies/cashout/inquiry', param)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [INQUIRY_OTP_CASHOUT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.post(`api/companies/cashout/otp?company_id=${param.company_id}`)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [PROCESS_CASHOUT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.post('api/companies/cashout', param)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [APPROVE_CREATE_COMPANY](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`api/companies/${param.id}/approval`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_DRAFT_IMPORT_USER](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/companies/${param.id}/private-user/draft`, param.query)
        .then(async ({ data }) => {
          await context.commit(SET_DRAFT_IMPORT_USER, data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_DETAIL_COMPANY](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/companies/${param.id}/settings/features`)
        .then(async ({ data }) => {
          await context.commit(SET_DETAIL_COMPANY, data.data);
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_FEATURES](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/companies/${param.id}/settings/features`)
        .then(async ({ data }) => {
          await context.commit(SET_FEATURES, data.data);
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_SETTING_POLICY](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/companies/${param.id}/settings/company_policy`)
        .then(async ({ data }) => {
          await context.commit(SET_SETTING_POLICY, data.data);
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_PRODUCT_SETTING](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/companies/${param.id}/settings/product_setting`)
        .then(async ({ data }) => {
          await context.commit(SET_PRODUCT_SETTING, data.data);
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_SETTING_COMPANY](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/companies/${param.id}/settings`)
        .then(async ({ data }) => {
          await context.commit(SET_SETTING_COMPANY, data.data);
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_USAGE](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/wage-access/${param.id}/usage`)
        .then(async ({ data }) => {
          await context.commit(SET_USAGE, data.data);
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // api/wage-access/:company_id/usage
  [APPROVAL_DRAFT_IMPORT_USER](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`api/companies/${param.id}/private-user/draft`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [DETAIL_COMPANIES](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/companies/${param.id}`)
        .then(async ({ data }) => {
          await context.commit(SET_DETAIL_COMPANIES, data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [UPDATE_STATUS_MYBENEFIT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`api/mybenefit/features/status/${param.id}`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [UPDATE_MY_BENEFIT_V2](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.put(`api/mybenefit/features/${param.id}`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [UPDATE_EFFECTIVE_DATE](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.put(`api/companies/${param.id}/settings/effective-date`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  [UPDATE_PAYROLL_DATE](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.put(`api/companies/${param.id}/settings/salary-period`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  [UPDATE_POLICY](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.put(`api/companies/${param.id}/settings/policy`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [UPDATE_PRODUCT_CONFIG](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.put(`api/companies/${param.id}/settings/features`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_MY_BENEFIT_LIST](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/mybenefit/features', param)
        .then(async ({ data }) => {
          await context.commit(SET_MY_BENEFIT_LIST, data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [DETAIL_MYBEN_BY_COMPANY](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/mybenefit/company/features/${param.id}`)
        .then(async ({ data }) => {
          await context.commit(SET_MYBEN_BY_COMPANY, data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [CREATE_MYBEN](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.post('api/mybenefit/features', param)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

const mutations = {
  [SET_COMPANIES](state, data) {
    if (!data.count) {
      data.rows = [];
      data.count = 0;
    } else {
      data.rows = data.rows.map((v) => {
        v.status_str = status[v.status]?.text;
        v.status_color = status[v.status]?.color;
        if (v.status === 'not_active') {
          v.status_color = 'tag-secondary';
        }
        v.mbayar_status = v.merchant_mbayar ? 'Active' : 'Not Active';
        v.mbayar_enabled = Boolean(v.merchant_mbayar);
        v.mbayar_status_color = v.merchant_mbayar ? 'tag-primary' : 'tag-default';
        v.mb_package = v.mybenefit_package ? v.mybenefit_package.package_name : '-';
        v.myben_period =
          v.mb_package !== '-'
            ? [
                moment(v.mybenefit_package_start_at, 'YYYY-MM-DD').format('DD MMM YYYY'),
                moment(v.mybenefit_package_end_at, 'YYYY-MM-DD').format('DD MMM YYYY'),
              ].join(' - ')
            : '-';
        v.mb_package_color = `tag-${v.mb_package.toLowerCase()}`;
        v.created_at_str = v.created_at
          ? moment(v.created_at).utcOffset(7).format('DD MMM YYYY, HH:mm')
          : '-';
        v.balance_loading = false;
        v.wallet_balance = 'Rp. 0';
        return v;
      });
    }
    state.companies = data;
  },
  [SET_REQUEST_COMPANY](state, data) {
    if (!data.count) {
      data.rows = [];
      data.count = 0;
    } else {
      data.rows = data.rows.map((v) => {
        v.status_str = status_request[v.status]?.text;
        v.status_color = status_request[v.status]?.color;
        if (v.status === 'submitted') {
          v.status_color = 'tag-secondary';
        } else if (v.status === 'waiting_verification') {
          v.status_color = 'tag-warning';
        } else if (v.source_type === 'approved') {
          v.status_color = 'tag-success';
        } else if (v.source_type === 'rejected_by_company') {
          v.status_color = 'tag-danger';
        } else if (v.source_type === 'rejected_by_bd') {
          v.status_color = 'tag-danger';
        } else if (v.source_type === 'rejected_by_hr') {
          v.status_color = 'tag-danger';
        } else if (v.source_type === 'cancelled') {
          v.status_color = 'tag-danger';
        }
        v.created_at_str = moment(v.created_at).format('DD MMM YYYY, HH:mm');
        return v;
      });
    }
    state.request_join = data;
  },
  [SET_TOTAL_SALARY_COMPANIES](state, data) {
    if (!data.count) {
      data.rows = [];
      data.count = 0;
    }
    state.salary = data;
  },
  [SET_DETAIL_COMPANY](state, data) {
    if (!data.count) {
      data.rows = [];
      data.count = 0;
    }
    state.detail_company = data;
  },
  [SET_FEATURES](state, data) {
    if (!data.count) {
      data.rows = [];
      data.count = 0;
    }
    state.features = data;
  },
  [SET_SETTING_POLICY](state, data) {
    if (!data.count) {
      data.rows = [];
      data.count = 0;
    }
    state.setting_policy = data;
  },
  [SET_PRODUCT_SETTING](state, data) {
    try {
      if (data.rows && data.rows.length > 0) {
        data.rows = data.rows.map((v) => {
          v.action_str = 'Create new promotion';
          v.dot_color = '#ff8f15';
          if (v.action === 'update') {
            v.action_str = 'Update promotion content';
            v.dot_color = '#f1c40f';
          }
          v.role_name = v.user.role.name;
          v.created_at_str = moment(v.created_at).format('DD MMM YYYY, HH:mm');
          v.created_at_simple = moment(v.created_at).format('DD MMM YYYY');
          return v;
        });
      }
      state.product_setting = data;
    } catch (error) {
      console.log(error);
    }
  },
  [SET_SETTING_COMPANY](state, data) {
    if (!data.count) {
      data.rows = [];
      data.count = 0;
    }
    state.setting_company = data;
  },
  [SET_USAGE](state, data) {
    if (!data.count) {
      data.rows = [];
      data.count = 0;
    }
    state.usage = data;
  },
  [SET_DETAIL_COMPANIES](state, data) {
    let rows = [];
    if (data) {
      if (data.setting) {
        let admin_fee_ewa = data.setting.admin_fee_ewa;
        data.setting.admin_fee_ewa_str = admin_fee_ewa
          ? `Rp. ${admin_fee_ewa.toLocaleString('id-ID')}`
          : 'Rp. 0';
      }
    } else {
      data.rows = [];
      data.count = 0;
    }
    data.rows = rows;
    state.companies = data;
  },
  [SET_MYBEN_BY_COMPANY](state, data) {
    if (data && data.rows) {
      state.myben_company = data;
    } else {
      state.myben_company = [];
    }
  },
  [SET_COMPANIES_PRIVATE](state, data) {
    if (!data.count) {
      state.company_private_user = {
        count: 0,
        rows: [],
      };
      return;
    }
    data.rows = data.rows.map((v) => {
      v.status_str = v.user_status ? 'Active' : 'Inactive';
      v.status_color = v.user_status ? 'tag-success' : 'tag-danger';
      v.login_at_str = v.login_at
        ? moment(v.login_at).utcOffset(7).format('DD MMM YYYY, HH:mm')
        : '-';
      v.created_at_str = v.created_at
        ? moment(v.created_at).utcOffset(7).format('DD MMM YYYY, HH:mm')
        : '-';
      return v;
    });
    data.rows.sort((a, b) =>
      a.full_name.localeCompare(b.full_name, undefined, { sensitivity: 'base' })
    );
    state.company_private_user = data;
  },
  [SET_PROVINCE](state, data) {
    if (data && data.rows) {
      state.province = data;
    } else {
      state.province = [];
    }
  },
  [SET_CITY](state, data) {
    if (data && data.rows) {
      state.city = data;
    } else {
      state.city = [];
    }
  },
  [SET_DRAFT_IMPORT_USER](state, data) {
    if (!data.count) {
      state.draft_import_user = {
        count: 0,
        rows: [],
      };
      return;
    }
    data.rows = data.rows.map((v) => {
      v.status_str = draft_status[v.status]?.text || 'Unknown';
      v.status_color = draft_status[v.status]?.color || 'tag-secondary';
      v.created_at_str = v.created_at
        ? moment(v.created_at).utcOffset(7).format('DD MMM YYYY, HH:mm')
        : '-';
      v.uploader_name = v.user_uploader?.full_name || v.user_uploader?.name;
      v.approver_name = v.user_approver?.full_name || v.user_approver?.name || '-';
      Object.assign(v, v.imported_data.data);
      return v;
    });
    state.draft_import_user = data;
  },
  [SET_MY_BENEFIT_LIST](state, data) {
    if (!data || !data.rows || !Array.isArray(data.rows)) {
      state.benefit_list_feature = {
        count: 0,
        rows: [],
      };
      return;
    }
    data.rows = data.rows.map((v, i) => {
      v.feature_status_str = status_myben[v.feature_status]?.text || '-';
      v.feature_status_color = status_myben[v.feature_status]?.color || '#fe0000';
      v.feature_is_maintenance_str = status_myben[v.feature_is_maintenance]?.text || '-';
      v.feature_is_maintenance_color = status_myben[v.feature_is_maintenance]?.color || '#fe0000';
      v.feature_is_new_str = status_myben[v.feature_is_new]?.text || '-';
      v.feature_is_coming_str = status_myben[v.feature_is_coming]?.text || '-';
      v.feature_is_coming_color = status_myben[v.feature_is_coming]?.color || '#fe0000';
      v.feature_is_new_color = status_myben[v.feature_is_new]?.color || '#fe0000';
      v.created_at_str = v.created_at
        ? moment(v.created_at).utcOffset(7).format('DD MMM YYYY, HH:mm')
        : '-';
      return v;
    });
    state.benefit_list_feature = {
      count: data.count || data.rows.length,
      rows: data.rows,
    };
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
